const CARACTERES_INVALIDOS = /[|°!"#$%&/()='?¿¡{}]/;

export const MAX_LARGO_DESCRIPCION = 45;

export const normalizarTexto = (texto) =>
  (texto || "").trim().normalize("NFC").toLocaleUpperCase("es-ES");

export const tieneCaracteresInvalidos = (texto) =>
  CARACTERES_INVALIDOS.test(texto || "");

/**
 * Guard de validación de descripción: obligatoria y largo máximo 45.
 * Retorna null si es válida; el mensaje de error en caso contrario.
 */
export const validarDescripcion = (texto) => {
  const desc = (texto ?? "").trim();
  if (!desc) {
    return "La descripción es obligatoria.";
  }
  if (desc.length > MAX_LARGO_DESCRIPCION) {
    return `La descripción no puede superar ${MAX_LARGO_DESCRIPCION} caracteres (actual: ${desc.length}).`;
  }
  return null;
};
